import { t } from "@/i18n-js/instance";
import { defaultData as customButtonDefaultData } from "@circle-react-shared/BuilderUI/DefaultBlocks/Content/CustomButtonBlock/CustomButtonBlockDefaultData";
import { defaultData as primaryButtonDefaultData } from "@circle-react-shared/BuilderUI/DefaultBlocks/Content/PrimaryButtonBlock/PrimaryButtonBlockDefaultData";
import { defaultData as secondaryButtonDefaultData } from "@circle-react-shared/BuilderUI/DefaultBlocks/Content/SecondaryButtonBlock/SecondaryButtonBlockDefaultData";

export type ButtonType = "primaryButton" | "secondaryButton" | "customButton";

export const BUTTON_TYPE_OPTIONS: { value: ButtonType; label: string }[] = [
  {
    value: "primaryButton",
    label: t("builder_ui.prop_type.styles.button_types.primary"),
  },
  {
    value: "secondaryButton",
    label: t("builder_ui.prop_type.styles.button_types.secondary"),
  },
  {
    value: "customButton",
    label: t("builder_ui.prop_type.styles.button_types.custom"),
  },
];

export const BUTTON_DEFAULT_DATA = {
  primaryButton: primaryButtonDefaultData,
  secondaryButton: secondaryButtonDefaultData,
  customButton: customButtonDefaultData,
};
